function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { SlotTransitionTimeoutError } from './errors/SlotTransitionTimeoutError';
var _promise = /*#__PURE__*/new WeakMap();
var _onDestroyCallback = /*#__PURE__*/new WeakMap();
var _timeoutEnabled = /*#__PURE__*/new WeakMap();
var _timeout = /*#__PURE__*/new WeakMap();
var _timeoutId = /*#__PURE__*/new WeakMap();
var _externalId = /*#__PURE__*/new WeakMap();
var _TransitionBlocker_brand = /*#__PURE__*/new WeakSet();
export var TransitionBlocker = /*#__PURE__*/function () {
  /**
   * Constructor for a TransitionBlocker instance.
   *
   * @param {Function} blockerExecutor - A function that performs the asynchronous task for the blocker.
   * @param {Function} blockerExecutionCancellation - A function that serves as a cancellation callback for the blocker execution.
   * @param {Object} [options] - Optional configuration options.
   * @param {number} [options.timeout] - The timeout duration in milliseconds for the blocker.
   * @param {string} [options.externalId] - An optional external identifier for the blocker.
   *
   * @throws {Error} Throws an error if `blockerExecutionCancellation` is not a function.
   *
   * @constructor
   */
  function TransitionBlocker(blockerExecutor, blockerExecutionCancellation, options) {
    var _this = this;
    _classCallCheck(this, TransitionBlocker);
    _classPrivateMethodInitSpec(this, _TransitionBlocker_brand);
    _classPrivateFieldInitSpec(this, _promise, void 0);
    _classPrivateFieldInitSpec(this, _onDestroyCallback, void 0);
    _classPrivateFieldInitSpec(this, _timeoutEnabled, false);
    _classPrivateFieldInitSpec(this, _timeout, 3000);
    _classPrivateFieldInitSpec(this, _timeoutId, void 0);
    _classPrivateFieldInitSpec(this, _externalId, 'UnnamedTransitionBlocker');
    _classPrivateFieldSet(_timeoutEnabled, this, !!(options !== null && options !== void 0 && options.timeout));
    _classPrivateFieldSet(_timeout, this, (options === null || options === void 0 ? void 0 : options.timeout) || _classPrivateFieldGet(_timeout, this));
    _classPrivateFieldSet(_externalId, this, options === null || options === void 0 ? void 0 : options.externalId);
    if (typeof blockerExecutionCancellation !== 'function') {
      throw new Error('TransitionBlocker blockerExecutionCancellation must be a function with cancellation callback');
    }
    _classPrivateFieldSet(_onDestroyCallback, this, blockerExecutionCancellation);
    var cancellablePromise = new Promise(function (resolve, reject) {
      if (blockerExecutor && typeof blockerExecutor.then === 'function') {
        blockerExecutor.then(resolve, reject);
      } else if (typeof blockerExecutor === 'function') {
        blockerExecutor(resolve, reject);
      } else {
        throw new Error('TransitionBlocker blockerExecutor must be a function or a promise');
      }
      if (_classPrivateFieldGet(_timeoutEnabled, _this)) {
        _classPrivateFieldSet(_timeoutId, _this, setTimeout(function () {
          reject(new SlotTransitionTimeoutError("TransitionBlocker timeout ".concat(_classPrivateFieldGet(_timeout, _this), "ms for blocker ").concat(_this.getId())));
        }, _classPrivateFieldGet(_timeout, _this)));
      }
    });

    // We have to guarantee clearing timeout in case promise is fulfilled or rejected
    _classPrivateFieldSet(_promise, this, cancellablePromise.then(function (result) {
      _assertClassBrand(_TransitionBlocker_brand, _this, _clearTimeout).call(_this);
      return result;
    }, function (error) {
      _assertClassBrand(_TransitionBlocker_brand, _this, _clearTimeout).call(_this);
      throw error;
    }));
  }
  return _createClass(TransitionBlocker, [{
    key: "then",
    value: function then(onFulfilled, onRejected) {
      _classPrivateFieldGet(_promise, this).then(onFulfilled, onRejected);
      return this;
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      _classPrivateFieldGet(_promise, this)["catch"](onRejected);
      return this;
    }
  }, {
    key: "getId",
    value: function getId() {
      return _classPrivateFieldGet(_externalId, this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(_onDestroyCallback, this).call(this, this._externalId);
    }
  }, {
    key: "promise",
    value: function promise() {
      return _classPrivateFieldGet(_promise, this);
    }
  }]);
}();
function _clearTimeout() {
  if (_classPrivateFieldGet(_timeoutEnabled, this) && _classPrivateFieldGet(_timeoutId, this)) {
    clearTimeout(_classPrivateFieldGet(_timeoutId, this));
    _classPrivateFieldSet(_timeoutId, this, null);
  }
}